import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ListIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='list'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z'
				fill='#2E2E6B'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.125 9H16.875'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.125 12H16.875'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M7.125 15H16.875'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ListIcon;
